import { render } from "./Manutencao.vue?vue&type=template&id=7e6dfede&scoped=true"
import script from "./Manutencao.vue?vue&type=script&lang=js"
export * from "./Manutencao.vue?vue&type=script&lang=js"

import "./Manutencao.vue?vue&type=style&index=0&id=7e6dfede&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6dfede"]])

export default __exports__